import React, { useEffect, useState } from "react";
import axios from "axios";

import NoImage from "../../../assets/images/addimage.png";
import LoadingGif from "../../../assets/images/Spin_loader.gif"
import { Button } from "react-bootstrap";

import {
    GET_PRODUCTS,
    DELETE_PRODUCTS,
    APP_BASE_URL
} from "../../AppConstant";

function DeleteProductPage({ setParentLoading }) {
    const [products, setProducts] = useState([]);
    const [productId, setProductId] = useState("");

    const [productName, setProductName] = useState("");
    const [imagePreview, setImagePreview] = useState(NoImage);

    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [isSelected, setIsSelected] = useState(false);

    const fetchProducts = async () => {
        try {
            setParentLoading(true);
            const res = await axios.get(GET_PRODUCTS);
            setProducts(res.data);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        } catch (err) {
            console.error(err);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleSelect = (item) => {
        setParentLoading(true);
        setProductId(item.id);
        setProductName(item.name);

        const imageUrl =
            APP_BASE_URL + "/products/getproductimage/" + item.id;

        const img = new Image();

        img.onload = () => {
            setImagePreview(imageUrl);
            setIsSelected(true);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        };

        img.onerror = () => {
            setImagePreview(NoImage);
            setIsSelected(true);
            console.error("Failed to load image");
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        };

        img.src = imageUrl;

    };

    const handleDelete = async () => {

        setParentLoading(true);

        if (!productId) {
            setErrorMessage("Please select a product");
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            return;
        }

        try {
            await axios.post(DELETE_PRODUCTS, {
                id: productId
            });

            setMessage("Product deleted successfully");
            setErrorMessage("");

            // reset UI
            setProductId("");
            setProductName("");
            setImagePreview(NoImage);
            setIsSelected(false);

            fetchProducts();
            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (error) {
            if (error.response?.data?.error) {
                setErrorMessage(error.response.data.error);
            } else {
                setErrorMessage("Error deleting product");
            }
            setMessage("");
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        }
    };

    return (
        <div>
           
            <div className="row">

                <div className="col-8">
                    <div className="form-group">
                        <label>Product Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={productName}
                            disabled
                        />
                    </div>

                    {isSelected && (
                        <Button
                            className="btn btn-danger mt-2"
                            onClick={handleDelete}
                        >
                            DELETE
                        </Button>
                    )}

                    {message && (
                        <p style={{ color: "green", fontWeight: "bold" }}>
                            {message}
                        </p>
                    )}

                    {errorMessage && (
                        <p style={{ color: "red", fontWeight: "bold" }}>
                            {errorMessage}
                        </p>
                    )}
                </div>

                <div className="col-4">
                    <img
                        src={imagePreview}
                        alt="Preview"
                        style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "contain"
                        }}
                    />
                </div>
            </div>


            <table className="mt-3 fw-bold">
                <thead className="bg-primary" style={{ color: "var(--bs-white)" }} >
                    <tr>
                        <th>S.No</th>
                        <th>Product Name</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody className="text-secondary" style={{ fontSize: "small" }}>
                    {products.map((item, index) => (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => handleSelect(item)}
                                >
                                    SELECT
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>


        </div>
    );
}

export default DeleteProductPage;